
// A helper function for passing down a ref created with createRef() to a component child
export default function setRef(ref, value) {
	if (typeof ref === 'function') {
		ref(value)
	} else if (ref) {
		ref.current = value
	}
}
